import { ClipLoader } from 'react-spinners'

import { Page } from 'src/components/layouts/Page'

export const Redirecting = () => {
  return (
    <Page title='Redirecting...'>
      <ClipLoader cssOverride={{ display: 'block' }} className='m-auto' />
    </Page>
  )
}
